module["exports"] = [
  "Ing.",
  "Mgr.",
  "JUDr.",
  "MUDr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/name/prefix.js
// module id = 2712
// module chunks = 2